import InquiryForm from './components/InquiryForm.vue'

export default InquiryForm
